import React, { useEffect, useRef, useState } from "react";
import styles from "./Product.module.css";
import { useAuth } from "../../components/context/Auth";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import Button from "../../components/updatedComponents/Dealers/Button";
// import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import { AddTO, DeleteTo, EditeTo, SettingTo, ViewTo, } from "../../components/icons/Icon3";
import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
import { TextColorCode } from "../../Utils/TextUtils";
// import GoToPage from "../../components/updatedComponents/Pagnation/GoToPage";
// import Pagenation from "../../components/updatedComponents/Pagnation/Pagenation";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import { useNavigate, useParams } from "react-router-dom";
import fetchData from "../../APIsControll/apiControll";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import { TemplateNotFound } from "../../components/icons/Icon2";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
const Items = () => {
  const { mode, managerId } = useAuth();
  const { collection, product } = useParams();
  const { show } = useToast();
  const navigate = useNavigate();
  const scrollDivRef = useRef();


  useEffect(() => {
    const scrollEl = scrollDivRef.current;

    const handleScroll = () => {
      localStorage.setItem("scroll-position", scrollEl.scrollTop);
    };
    scrollEl.addEventListener("scroll", handleScroll);
  }, []);

  const product_id = new URLSearchParams(window.location.search).get(
    "productId"
  );
  const collection_Id = new URLSearchParams(window.location.search).get(
    "collectionId"
  );
  const [toggle, setToggle] = useState(false);
  const [loading, setLoading] = useState({
    items: false,
  });
  const [modelContainer, setModeContiner] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [ProductSerach, setProductSerach] = useState('');
  const [data, setData] = useState([]);


  useEffect(() => {
    if (ProductSerach.trim() === '') {
      setFilteredData(data);
      return;
    }
    const searchTerm = ProductSerach.toLowerCase();
    const filteredStyles = data?.filter(item =>
      item.itemNo.toLowerCase().includes(searchTerm)
    );
    setFilteredData(filteredStyles);
  }, [ProductSerach, data]);


  const handleSetModel = (con) => {
    setToggle({ ...toggle, modelToggle: true });
    setModeContiner(con);
  };
  async function getItems() {
    try {
      setLoading({ ...loading, items: true });
      const payload = {
        collection_id: collection_Id,
        product_id: product_id,
      };
      const res = await fetchData(`content/Items`, payload);
      if (res.status === "success") {
        setData(res?.data);
        setFilteredData(res?.data);
        return;
      }
      if (res.status === "failed") {
        show(res.msg, "error");
        return;
      }
    } catch (error) {
      show("", "error");
    } finally {
      setLoading({ ...loading, items: false });
    }
  }
  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const DeleteProduct = async (id) => {
    try {
      setLoading({ ...loading, items: true });
      const payload = {
        managerId: managerId,
        _id: id,
      };
      const res = await fetchData(`content/deleteItem`, payload);
      if (res.status === "success") {
        getItems();
        return;
      }
      if (res.status === "failed") {
        show(res.msg, "error");
        return;
      }
    } catch (error) {
      show("", "error");
    } finally {
      setLoading({ ...loading, items: false });
    }
  };

  useEffect(() => {
    if (!loading.items) {
      const savedScroll = localStorage.getItem("scroll-position");
      if (savedScroll && scrollDivRef.current) {
        scrollDivRef.current.scrollTop = parseInt(savedScroll);
      }
    }
  }, [loading.items]);
  return (
    <div className={styles.Main_Layout}>
      <ModalWrapper
        isOpen={toggle.modelToggle}
        onClose={() =>
          setToggle({ ...toggle, modelToggle: !toggle.modelToggle })
        }
      >
        {modelContainer}
      </ModalWrapper>
      <div
        className={styles.Layout}
        style={{
          backgroundColor: mode ? "#2B2D31" : "#F8F9FC",
          color: mode ? "#fff" : "#000",
        }}
      >
        <div className={styles.Top_bar_css}>
          <div className={styles.gobackClass}>
            <TopTabBar text={`Product/${product}/${collection}`} />
          </div>
          <div className={styles.btn_Continer}>
            <div>
              <InputTag
                placeholderText={"Search.."}
                placeholderType={"text"}
                padding={"10px"}
                fontSize={"12px"}
                maxLength={20}
                // onChange={(e) => setProductSerach(e)}
                onChange={(e) => setProductSerach(e.target.value)}
              />
            </div>
            {/* <div>
              {" "}
              <DropDown
                label={"Sort By"}
                options={[
                  { label: "Active" },
                  { label: "Disabled" },
                  { label: "Delete" },
                  { label: "Ascending" },
                  { label: "Descending" },
                ]}
              />{" "}
            </div> */}
            <div>
              <Button
                buttonText={"Add Item"}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#fff"}
                buttonIcon={<AddTO />}
                buttonClick={() => navigate(`/products/item/newitem/${product}/${collection}?itemId=${""}&disabled=${false}&product_id=${product_id}&collection_id=${collection_Id}`)}
              />
            </div>
          </div>
        </div>

        <div className={styles.container}>
          <ul className={styles.responsiveTable}>
            <li
              className={styles.tableHeader}
              style={
                mode
                  ? { backgroundColor: "#232529", color: "#fafafa" }
                  : { backgroundColor: "#D9DCE5" }
              }
            >
              <div className={styles.col}>S/N</div>
              <div className={styles.col}>Status</div>
              <div className={styles.col}>Product Name</div>
              <div className={styles.col}>Delete</div>
              <div className={styles.col}>Setting</div>
              <div className={styles.col}>Edit</div>
              <div className={styles.col}>View</div>
            </li>
            <div ref={scrollDivRef}
              className={mode ? styles.Table_row : styles.Table_row_light}

            >
              {loading?.items ? (
                <Skeleton lines={10} thickness={5} />
              ) : data?.length === 0 ? (
                <NoDataFound icon={<TemplateNotFound />} />
              ) : (
                filteredData?.map((item, i) => (
                  <li className={styles.tablerow}
                    style={{
                      backgroundColor: mode ? "#1B1D21" : "#fff",
                      color: mode ? "#fafafa" : "#000",
                      border:
                        localStorage.getItem("click-Id") === item._id ? "1px solid #4164E3" : "none",
                    }}
                    key={item?._id}
                    onClick={() => {
                      localStorage.setItem("click-Id", item._id)
                      navigate(`/products/item/${product}/${collection}?itemId=${item._id}&disabled=${true}&product_id=${product_id}&collection_id=${collection_Id}&itemname=${item?.itemNo}`)
                    }}
                  >
                    <div className={styles.col} data-label="Status" >
                      {" "}
                      {i + 1}
                    </div>
                    <div className={styles.col} data-label="Status" style={{ color: TextColorCode(item?.status) }}   >
                      {" "}
                      {item?.status}
                    </div>
                    <div
                      className={styles.col}
                      data-label="Product Name"
                      style={{ color: mode ? "#fff" : "#000" }}
                    >
                      {item?.itemNo}
                    </div>
                    <div
                      className={styles.col}
                      data-label="Delete"
                      style={{ color: mode ? "#fff" : "#000" }}
                    >
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSetModel(
                            <>
                              <ManagerModal
                                heading={"Delete Product"}
                                centerHeading={
                                  "Are you sure you want to Delete?"
                                }
                                subHeading={
                                  "To confirm! type delete in the text field."
                                }
                                targetWord={"delete"}
                                handleSubmit={() => {
                                  DeleteProduct(item._id);
                                }}
                                handleCloseModal={() =>
                                  setToggle({ ...toggle, modelToggle: false })
                                }
                              />
                            </>
                          );
                        }}
                      >
                        {" "}
                        <DeleteTo />{" "}
                      </span>
                    </div>
                    <div
                      className={styles.col}
                      data-label="Setting"
                      style={{ color: mode ? "#fff" : "#000" }}
                    >
                      <SettingTo mode={mode} />
                    </div>
                    <div
                      className={styles.col}
                      data-label="Edit"
                      style={{ color: mode ? "#fff" : "#000" }}
                    >
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          localStorage.setItem("click-Id", item._id)
                          navigate(
                            `/products/item/${product}/${collection}?itemId=${item._id
                            }&disabled=${false}&product_id=${product_id}&collection_id=${collection_Id}&itemname=${item?.itemNo
                            }`
                          );
                        }}
                      >
                        <EditeTo />{" "}
                      </span>
                    </div>
                    <div
                      className={styles.col}
                      data-label="View"
                      style={{ color: mode ? "#fff" : "#000" }}
                    >
                      <ViewTo />
                    </div>
                  </li>
                ))
              )}
            </div>
          </ul>
        </div>

        {/* <div
          className={styles.mgx_pagination}
          style={{ backgroundColor: mode ? "#232529" : "#fff" }}
        >
          <div style={{ width: "50%" }}>
            <div
              style={{
                width: "50%",
                display: "flex",
                justifyContent: "flex-start",
                fontSize: "14px",
              }}
            >
              <GoToPage key={"1"} />
            </div>
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              justifyContent: "flex-end",
              fontSize: "12px",
            }}
          >
            <Pagenation key={"1"} />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Items;
